var _circle, _circle2, _rect, _rect2, _path, _path2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path3, _path4, _circle3, _circle4, _circle5, _circle6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateCompanyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 70,
    r: 70,
    fill: "#256AF5",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#E3E9FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.9199,
    y: 16,
    width: 12.2142,
    height: 29.5177,
    fill: "url(#paint0_linear_1852_162954)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 81.5977,
    y: 16,
    width: 12.2142,
    height: 29.5177,
    fill: "url(#paint1_linear_1852_162954)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6514 27.1973L71.419 49.0811V123.893H27.6514V27.1973Z",
    fill: "url(#paint2_linear_1852_162954)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4189 27.1973L115.187 49.0811V123.893H71.4189V27.1973Z",
    fill: "url(#paint3_linear_1852_162954)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 35.7949,
    y: 53.6602,
    width: 8.14282,
    height: 18.3213,
    fill: "url(#paint4_linear_1852_162954)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 80.5801,
    y: 53.6602,
    width: 8.14282,
    height: 18.3213,
    fill: "url(#paint5_linear_1852_162954)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 35.7949,
    y: 75.0352,
    width: 8.14282,
    height: 18.3213,
    fill: "url(#paint6_linear_1852_162954)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 80.5801,
    y: 75.0352,
    width: 8.14282,
    height: 18.3213,
    fill: "url(#paint7_linear_1852_162954)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 35.7949,
    y: 96.4102,
    width: 8.14282,
    height: 18.3213,
    fill: "url(#paint8_linear_1852_162954)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 80.5801,
    y: 96.4102,
    width: 8.14282,
    height: 18.3213,
    fill: "url(#paint9_linear_1852_162954)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 54.5488,
    y: 53.6602,
    width: 8.14282,
    height: 18.3213,
    fill: "url(#paint10_linear_1852_162954)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 98.9014,
    y: 53.6602,
    width: 8.14282,
    height: 18.3213,
    fill: "url(#paint11_linear_1852_162954)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 54.5488,
    y: 75.0352,
    width: 8.14282,
    height: 18.3213,
    fill: "url(#paint12_linear_1852_162954)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 98.9014,
    y: 73.7695,
    width: 8.14282,
    height: 18.3213,
    fill: "url(#paint13_linear_1852_162954)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 54.5488,
    y: 96.707,
    width: 8.14282,
    height: 18.3213,
    fill: "url(#paint14_linear_1852_162954)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 98.9014,
    y: 95.1445,
    width: 8.14282,
    height: 18.3213,
    fill: "url(#paint15_linear_1852_162954)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6553,
    y: 19.3984,
    width: 12.7432,
    height: 4.24773,
    fill: "#3EE78D"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 81.7344,
    y: 19.3984,
    width: 11.8936,
    height: 4.24773,
    fill: "#3EE78D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3301 46.5353L71.4193 49.0799V123.892H66.3301V46.5353Z",
    fill: "url(#paint16_linear_1852_162954)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.821 124.401H19V122.365H122.821V124.401Z",
    fill: "url(#paint17_linear_1852_162954)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 47,
    r: 2,
    fill: "#3EE78D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 89,
    r: 2,
    fill: "#3EE78D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.5,
    cy: 28.5,
    r: 1.5,
    fill: "#3EE78D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 83.5,
    r: 1.5,
    fill: "#3EE78D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1852_162954",
    x1: 49.4189,
    y1: 40.2954,
    x2: 49.4189,
    y2: 20.7842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16329D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4A6CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1852_162954",
    x1: 88.0966,
    y1: 40.2954,
    x2: 88.0966,
    y2: 20.7842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16329D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4A6CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1852_162954",
    x1: 42.9345,
    y1: 20.3117,
    x2: 42.9345,
    y2: 189.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A3495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1852_162954",
    x1: 86.7021,
    y1: 20.3117,
    x2: 86.702,
    y2: 189.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A3495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1852_162954",
    x1: 38.2148,
    y1: 97.7495,
    x2: 39.4976,
    y2: 40.0753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#5877EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1852_162954",
    x1: 83,
    y1: 97.7495,
    x2: 84.2827,
    y2: 40.0753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#5877EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1852_162954",
    x1: 38.2148,
    y1: 119.125,
    x2: 39.4976,
    y2: 61.4503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#5877EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1852_162954",
    x1: 83,
    y1: 119.125,
    x2: 84.2827,
    y2: 61.4503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#5877EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1852_162954",
    x1: 38.2148,
    y1: 140.5,
    x2: 39.4976,
    y2: 82.8253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#5877EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1852_162954",
    x1: 83,
    y1: 140.5,
    x2: 84.2827,
    y2: 82.8253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#5877EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1852_162954",
    x1: 56.9688,
    y1: 97.7495,
    x2: 58.2515,
    y2: 40.0753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#5877EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1852_162954",
    x1: 101.321,
    y1: 97.7495,
    x2: 102.604,
    y2: 40.0753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#5877EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1852_162954",
    x1: 56.9688,
    y1: 119.125,
    x2: 58.2515,
    y2: 61.4503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#5877EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1852_162954",
    x1: 101.321,
    y1: 117.859,
    x2: 102.604,
    y2: 60.1847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#5877EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1852_162954",
    x1: 56.9688,
    y1: 140.796,
    x2: 58.2515,
    y2: 83.1222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#5877EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1852_162954",
    x1: 101.321,
    y1: 139.234,
    x2: 102.604,
    y2: 81.5597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#5877EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1852_162954",
    x1: 69.038,
    y1: 180.387,
    x2: 69.0379,
    y2: 37.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1852_162954",
    x1: 66.2089,
    y1: 125.104,
    x2: 66.2089,
    y2: 120.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#4766DC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateCompanyIcon);
export default __webpack_public_path__ + "static/media/create-company-icon.6f13c758d3076240203237f7f16f0949.svg";
export { ForwardRef as ReactComponent };